import Swiper from 'swiper';
import 'swiper_dir/css/swiper.min.css'

const swiper = new Swiper('.js-slider1', {
  slidesPerView: 1,
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: '.hero-Main_Pagination',
    clickable: true,
  },
});
